import React from 'react';
import styled from 'styled-components';
import { Text, TextButton, IconButtonProps, IconButton } from '@oneaudi/unified-web-components';
import {
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_SPACE_FIXED_500,
  SYS_SPACE_RELATIVE_LG,
  SYS_SPACE_RELATIVE_XS,
  SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT,
  SYS_PAGE_MARGIN_XS,
  SYS_BREAKPOINT_SM,
  SYS_PAGE_MARGIN_SM,
  SYS_PAGE_MARGIN_MD,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_2_XL,
  SYS_SPACE_FIXED_1200,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_600,
} from '@oneaudi/unified-web-common';
// eslint-disable-next-line import/no-extraneous-dependencies
import { dynamicStyling, dynamicStylingHelper, GetSafeColorDesignToken } from '@oneaudi/vtp-shared';
import { SYS_SPACE_FIXED_150 } from '@oneaudi/unified-web-alpha-common';

export const QuickFilters = styled.div`
  display: none;

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    display: block;
  }
`;

export const QuickFiltersWrapper = styled.div`
  --sidebar-width-lg: 256px;
  --sidebar-width-xl: 296px;
  --sidebar-width-2xl: 408px;
  --toolbar-height: 80px;
  --padding-top-md: 32px;
  --padding-bottom-md: calc(
    ${SYS_SPACE_FIXED_1200} + ${SYS_PAGE_MARGIN_MD} - ${SYS_SPACE_FIXED_500}
  );

  padding: 48px ${SYS_PAGE_MARGIN_XS}
    calc(${SYS_SPACE_FIXED_1200} + ${SYS_PAGE_MARGIN_XS} - ${SYS_SPACE_FIXED_500})
    ${SYS_PAGE_MARGIN_XS};

  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    padding: 32px ${SYS_PAGE_MARGIN_SM}
      calc(${SYS_SPACE_FIXED_1200} + ${SYS_PAGE_MARGIN_SM} - ${SYS_SPACE_FIXED_500})
      ${SYS_PAGE_MARGIN_SM};
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding: var(--padding-top-md) ${SYS_PAGE_MARGIN_MD} var(--padding-bottom-md)
      ${SYS_PAGE_MARGIN_MD};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    min-width: var(--sidebar-width-lg);
    max-width: var(--sidebar-width-lg);

    // sticky behaviour
    position: sticky;
    top: var(--toolbar-height);
    // viewport minus toolbar minus padding-bottom
    height: calc(100vh - var(--toolbar-height) - ${SYS_SPACE_FIXED_500});
    overflow-y: auto;
    margin-bottom: ${SYS_SPACE_FIXED_600};
    padding-bottom: ${SYS_SPACE_FIXED_500};
    padding-top: 0;
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    min-width: var(--sidebar-width-xl);
    max-width: var(--sidebar-width-xl);
  }

  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    min-width: var(--sidebar-width-2xl);
    max-width: var(--sidebar-width-2xl);
  }
`;

export const RenderedQuickFiltersWrapper = styled.div``;

export const SelectedFiltersHeadline = styled(Text)`
  ${dynamicStylingHelper('color: var(--Sem-Color-Forms-Foreground-Text-Caption, #666666)')};
`;

export const QuickFiltersFooter = styled.div`
  display: flex;
  padding: ${dynamicStylingHelper(
    `${SYS_SPACE_RELATIVE_XS} ${SYS_SPACE_RELATIVE_LG}`,
    `${SYS_SPACE_FIXED_150} ${SYS_PAGE_MARGIN_XS}`
  )};
  margin-top: ${dynamicStylingHelper(SYS_SPACE_FIXED_500, '0')};
  border-top: ${dynamicStylingHelper(`1px solid ${SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT}`, 'unset')};
  ${dynamicStyling({
    legacy: `
        box-shadow: 0px 8px 16px 0px ${GetSafeColorDesignToken('INDICATOR_DEFAULT_DARK')}`,
  })}
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  gap: 10px;
  background: ${GetSafeColorDesignToken('QUICK_FILTERS_FOOTER')};
  backdrop-filter: blur(${GetSafeColorDesignToken('FILTER_OVERLAY_BLUR')});
  justify-content: center;

  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    padding: ${dynamicStylingHelper(
      `${SYS_SPACE_RELATIVE_XS} ${SYS_SPACE_RELATIVE_LG}`,
      `${SYS_SPACE_FIXED_150} ${SYS_PAGE_MARGIN_SM}`
    )};
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding: ${dynamicStylingHelper(
      `${SYS_SPACE_RELATIVE_XS} ${SYS_SPACE_RELATIVE_LG}`,
      `${SYS_SPACE_FIXED_150} ${SYS_PAGE_MARGIN_MD}`
    )};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-top: 0;
    border-top: unset;
    box-shadow: unset;
    position: static;
    justify-content: center;
    padding: unset;
    background: unset;
  }
`;

export const StyledCloseButton = styled((props) => <IconButton {...props} />)<IconButtonProps>`
  position: fixed;
  right: ${dynamicStylingHelper('0', SYS_SPACE_FIXED_100)};
  top: ${dynamicStylingHelper('0', SYS_SPACE_FIXED_100)};
  border: none;

  button {
    border: none;
  }
`;

export const StyledAdvancedFiltersButton = styled((props) => (
  <TextButton {...props} />
))<IconButtonProps>`
  width: 100%;
  box-shadow: none;
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    box-shadow: inset 0 0 0 1px ${GetSafeColorDesignToken('INDICATOR_DEFAULT_DARK')};
  }
`;
